import {Injectable} from '@angular/core';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpService} from 'src/app/services/http.service';
import {AgencyContacts, AgencyInfoResponse} from "../models/agencies";
import { Agencies, AgencyTier1, AgencyTier2, AgencyTier2List, AgencyTier1List } from '../models/agencies';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {

  constructor(private httpService: HttpService) {
  }

  getAgencies(): Observable<AgencyTier1List> {
    return this.httpService.Get('/get-tier_1-agency-list');
  }

  getTier2Agencies(agency1Id: number): Observable<any> {
    return this.httpService.Get('/tier2/' + agency1Id);
  }

  getAgenciesTier2(agency1Id: number): Observable<AgencyTier2List> {
    return this.httpService.Get('/tier2/' + agency1Id);
  }

  getListOfAgencyPOC(tier1AgencyId: number, tier2AgencyId?: number): Observable<AgencyContacts> {
    let httpParams: HttpParams = new HttpParams();
    httpParams = httpParams.append('tier1_Agency_Id', tier1AgencyId)

    if (tier2AgencyId) {
      httpParams = httpParams.append('tier2_Agency_Id', tier2AgencyId)
    } else {
      httpParams = httpParams.append('tier2_Agency_Id', "null")
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };

    return this.httpService.Post('/view-agency-user-info', httpParams, options);
  }

  registerAgencyInfo(formData: any): Observable<AgencyInfoResponse> {
    const httpParams =  this.httpService.createHttpParams(formData);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };

    return this.httpService.Post('/register-agency-info', httpParams, options);
  }

  updateAgencyInfo(formData: any): Observable<AgencyInfoResponse> {
    const httpParams =  this.httpService.createHttpParams(formData);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };

    return this.httpService.Post('/edit-agency-info', httpParams, options);
  }

  updateAgencyAddress(formData: any): Observable<AgencyInfoResponse> {
    const httpParams =  this.httpService.createHttpParams(formData);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };

    return this.httpService.Post('/update-agency-add', httpParams, options);
  }
}
